import _ from 'lodash';
import MediumEditor from 'medium-editor';

const CARD_CLASS_NAMES = ['contributor-card', 'fund-card', 'wire-card'];
const CLASS_NAMES = [...CARD_CLASS_NAMES];

const isCard = elem => elem && _.intersection(CARD_CLASS_NAMES, elem.classList).length > 0;

const DeleteEmbedCard = MediumEditor.Extension.extend({
  name: 'delete-embed-card',

  init() {
    MediumEditor.Extension.prototype.init.call(this);

    this.subscribe('editableKeydownDelete', this.handleKeydownDelete.bind(this));

    this.findEmbedElement.bind(this);
    this.deleteEmbedElement.bind(this);
  },

  handleKeydownDelete(event) {
    const embed = this.findEmbedElement();

    if (embed) {
      event && event.preventDefault();
      this.deleteEmbedElement(embed);
    }
  },

  findEmbedElement() {
    const current = this.base.getSelectedParentElement();
    let embed = _.compact(CLASS_NAMES.map(name => current.closest(`.${name}`)))[0];

    if (!embed) {
      const caret = MediumEditor.selection.getCaretOffsets(current).left;

      if (caret === 0) {
        const previous = current.previousElementSibling;

        if (previous && isCard(previous)) {
          embed = previous;
        }
      }
    }

    return embed;
  },

  deleteEmbedElement(embed) {
    const previous = embed.previousElementSibling;

    embed.remove();

    if (previous) {
      this.base.selectElement(previous);
      MediumEditor.selection.clearSelection(document);
    }

    this.base.trigger('editableInput');
  },
});

export default DeleteEmbedCard;
